import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const CreateMacue = async (payload) => {
  try {
    const response = await APIs.post('/create_macue', payload);

    if (response?.data?.message === 'success') {
      toast('Created Successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllMacue = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_all_macue/${payload.page}/${payload.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllMajorMacue = async () => {
  try {
    const response = await APIs.get(`/get_all_major_macue`);

    if (response?.data?.message === 'success') {
      toast('successfully fetched');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const DeleteMacue = async (payload) => {
  try {
    const response = await APIs.post(`/delete_macue`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully deleted');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleMacueDetails = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_macue/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const EditMacue = async (payload) => {
  try {
    const response = await APIs.patch(`/edit_macue/${payload?._id}`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const SearchForMacueByName = async (payload) => {
  try {
    const response = await APIs.get(
      `/search_for_macue_by_title/${payload?.title}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const MacueServices = {
  CreateMacue,
  getAllMacue,
  getAllMajorMacue,
  DeleteMacue,
  getSingleMacueDetails,
  EditMacue,
  SearchForMacueByName,
};

export default MacueServices;
